module.exports = __webpack_public_path__ + "img/horizontal_6_3_8003.218f1065.png";